import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/images/diamonds-logo.png'


const _hoisted_1 = { id: "home" }
const _hoisted_2 = { class: "isolate bg-gray-900" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]\"><svg class=\"relative left-[calc(50%-11rem)] -z-10 h-[21.1875rem] max-w-none -translate-x-1/2 rotate-[30deg] sm:left-[calc(50%-30rem)] sm:h-[42.375rem]\" viewBox=\"0 0 1155 678\"><path fill=\"url(#f4773080-2a16-4ab4-9fd7-579fec69a4f7)\" fill-opacity=\".2\" d=\"M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z\"></path><defs><linearGradient id=\"f4773080-2a16-4ab4-9fd7-579fec69a4f7\" x1=\"1155.49\" x2=\"-78.208\" y1=\".177\" y2=\"474.645\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#0D81EC\"></stop><stop offset=\"1\" stop-color=\"#0D81EC\"></stop></linearGradient></defs></svg></div>", 1)
const _hoisted_4 = { class: "px-6 pt-6 lg:px-8" }
const _hoisted_5 = {
  class: "flex items-center justify-between",
  "aria-label": "Global"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex lg:flex-1" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#home",
    class: "-m-1.5 p-1.5"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Your Company"),
    /*#__PURE__*/_createElementVNode("img", {
      class: "h-8",
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_7 = { class: "flex lg:hidden" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_9 = { class: "hidden lg:flex lg:gap-x-12" }
const _hoisted_10 = { class: "hidden lg:flex lg:flex-1 lg:justify-end" }
const _hoisted_11 = {
  href: "https://dashboard.diamondshub.it",
  target: "_blank",
  class: "flex row justify-center items-center text-base font-semibold leading-7 text-white"
}
const _hoisted_12 = { class: "flex items-center justify-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "#home",
  class: "-m-1.5 p-1.5"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Your Company"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close menu", -1)
const _hoisted_15 = { class: "mt-6 flow-root" }
const _hoisted_16 = { class: "-my-6 divide-y divide-gray-500/25" }
const _hoisted_17 = { class: "space-y-2 py-6" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "py-6" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://dashboard.diamondshub.it",
    target: "_blank",
    class: "-mx-3 block rounded-lg py-2.5 px-3 text-base font-semibold leading-6 text-white hover:bg-gray-400/10"
  }, "Accedi")
], -1)

import { ref } from "vue";
import { Dialog, DialogPanel } from "@headlessui/vue";
import { ChevronRightIcon } from "@heroicons/vue/20/solid";
import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const navigation = [
	{ name: "Home", href: "/" },
	{ name: "Recensioni", href: "reviews" },
	{ name: "Qualitá", href: "quality" },
	{ name: "Formazione", href: "training" },
	{ name: "Revenue", href: "revenue" },
	{ name: "Francis", href: "francis" },
];

const mobileMenuOpen = ref(false);

const goToPage = (link: string) => {
	router.push(link);
	setTimeout(() => (mobileMenuOpen.value = false), 200);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("nav", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: "-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenuOpen.value = true))
            }, [
              _hoisted_8,
              _createVNode(_unref(Bars3Icon), {
                class: "h-6 w-6",
                "aria-hidden": "true"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
              return _createVNode(_component_router_link, {
                key: item.name,
                to: item.href,
                class: "text-sm font-semibold leading-6 text-white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", _hoisted_11, [
              _createTextVNode("Accedi "),
              _createVNode(_unref(ChevronRightIcon), {
                class: "h-5 w-5 text-gray-500",
                "aria-hidden": "true"
              })
            ])
          ])
        ]),
        _createVNode(_unref(Dialog), {
          as: "div",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (mobileMenuOpen.value = false)),
          open: mobileMenuOpen.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogPanel), {
              focus: "true",
              class: "fixed inset-0 z-10 overflow-y-auto bg-gray-900 px-6 py-6 lg:hidden"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("button", {
                    type: "button",
                    class: "-m-2.5 rounded-md p-2.5 text-gray-400",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileMenuOpen.value = false))
                  }, [
                    _hoisted_14,
                    _createVNode(_unref(XMarkIcon), {
                      class: "h-6 w-6",
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                        return _createElementVNode("a", {
                          key: item.name,
                          onClick: ($event: any) => (goToPage(item.href)),
                          class: "-mx-3 block rounded-lg py-2 px-3 text-base font-semibold leading-7 text-white hover:bg-gray-400/10"
                        }, _toDisplayString(item.name), 9, _hoisted_18)
                      }), 64))
                    ]),
                    _hoisted_19
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})